export default __webpack_public_path__ + "33f5696c7b2d535d58302cc38b5740e2.svg";